import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import useSecureFileEffect from '../../hooks/useSecureFileEffect';

const DocumentPreviewDialog: React.FC<{ url: string | null; onClose: () => void }> = ({
  url,
  onClose,
}) => {
  const { t } = useTranslation();

  const httpsUrl =
    url != null
      ? window.location.protocol === 'https:'
        ? url.replace('http', 'https')
        : url
      : null;

  const { fileSrc } = useSecureFileEffect(
    (() => {
      if (url == null) return null;
      return window.location.protocol === 'https:' ? url.replace('http', 'https') : url;
    })(),
  );

  return (
    <Dialog open={httpsUrl != null} onClose={onClose} fullWidth maxWidth="lg" fullScreen>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">{httpsUrl}</Typography>
          <Button onClick={onClose}>{t('button-close')}</Button>
        </Stack>
      </DialogTitle>

      {fileSrc != null && (
        <iframe
          src={fileSrc}
          title={fileSrc ?? ''}
          width="100%"
          style={{ maxWidth: '100%', height: '100%' }}
        />
      )}
    </Dialog>
  );
};

export default DocumentPreviewDialog;
